import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex justify-content-end"
}
const _hoisted_3 = { class: "col-auto mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel me-2 fs-3" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Filtro padrão ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-funnel-fill me-2 fs-3" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Filtro avançado ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "col-auto mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-ui-checks p-0 fs-2" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-ui-checks-grid p-0 fs-2" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "col-auto mb-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  id: "kt_drawer_selecao_campos_button",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: "Seleção de campos",
  class: "d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white px-3 ms-2"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-ui-radios p-0 fs-2" })
], -1)
const _hoisted_17 = {
  id: "kt_drawer_selecao_campos",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-toggle": "#kt_drawer_selecao_campos_button",
  "data-kt-drawer-close": "#kt_drawer_selecao_campos_close",
  "data-kt-drawer-name": "selecao_campos",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'350px', 'md': '400px'}",
  "data-kt-drawer-direction": "end"
}
const _hoisted_18 = { class: "card rounded-0 w-100" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header pe-5\"><div class=\"card-title\">Seleção de campos:</div><div class=\"card-toolbar\"><div class=\"btn btn-icon btn-sm btn-active-light-primary\" id=\"kt_drawer_selecao_campos_close\"><span class=\"svg-icon svg-icon-2x\"><img src=\"media/icons/duotune/arrows/arr061.svg\"></span></div></div></div>", 1)
const _hoisted_20 = { class: "card-body hover-scroll-overlay-y" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-4" }, " Informe aqui todos os campos que deseja vizualizar ", -1)
const _hoisted_22 = { class: "row mt-4" }
const _hoisted_23 = { class: "col-auto mb-4" }
const _hoisted_24 = { class: "fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus ms-1 fs-2" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Campo ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "col-auto mb-4" }
const _hoisted_29 = { class: "fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg ms-1 fs-2" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Confirmar ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "border-top" }
const _hoisted_34 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "form-check form-check-sm form-check-custom form-check-solid"
}
const _hoisted_37 = ["onChange"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "form-check form-check-sm form-check-custom form-check-solid"
}
const _hoisted_40 = ["onChange"]
const _hoisted_41 = { class: "fw-bold text-gray-600 h-auto" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onDblclick", "data-title"]
const _hoisted_44 = ["data-title"]
const _hoisted_45 = {
  key: 0,
  class: "w-auto"
}
const _hoisted_46 = {
  key: 1,
  class: "w-auto"
}
const _hoisted_47 = { key: 2 }
const _hoisted_48 = {
  key: 3,
  class: "text-nowrap w-auto"
}
const _hoisted_49 = {
  key: 1,
  class: "odd"
}
const _hoisted_50 = {
  colSpan: 12,
  class: "dataTables_empty"
}
const _hoisted_51 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Aguarde, carregando...", -1)
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  key: 2,
  class: "row m-0"
}
const _hoisted_56 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_57 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QueryBuilder = _resolveComponent("QueryBuilder")!
  const _component_SelectQueryBuilder = _resolveComponent("SelectQueryBuilder")!
  const _component_KTDatatableFilter = _resolveComponent("KTDatatableFilter")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.viewModel && _ctx.showFilter && _ctx.showFilters && _ctx.verificaTipoPacote())
      ? (_openBlock(), _createBlock(_component_QueryBuilder, {
          key: 0,
          viewModel: _ctx.viewModel,
          selectQuery: _ctx.selectQuery != `` ? _ctx.selectQuery : _ctx.tableData.selectOData,
          selectFiltro: _ctx.selectFiltro,
          onAtualizarSelectFiltro: _ctx.atualizarSelectFiltro,
          onGerarFiltro: _ctx.queryFilter
        }, null, 8, ["viewModel", "selectQuery", "selectFiltro", "onAtualizarSelectFiltro", "onGerarFiltro"]))
      : _createCommentVNode("", true),
    (_ctx.showFilters && _ctx.verificaTipoPacote())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.viewModel && _ctx.showFilter)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ocultarQueryFilter && _ctx.ocultarQueryFilter(...args))),
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: "Retorna para as opções de filtros padrão",
                  class: "btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
                }, _hoisted_6))
              : (_ctx.viewModel && !_ctx.showFilter)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exibirQueryFilter && _ctx.exibirQueryFilter(...args))),
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: "Exibe todas as opções de filtros",
                    class: "btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white"
                  }, _hoisted_9))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.showTableCustom && _ctx.viewModel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ocultarTableCustom && _ctx.ocultarTableCustom(...args))),
                  "data-bs-toggle": "tooltip",
                  "data-bs-placement": "top",
                  title: "Retorna para a visualização padrão",
                  class: "d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white px-3 ms-2"
                }, _hoisted_12))
              : (!_ctx.showTableCustom && _ctx.viewModel)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exibirTableCustom && _ctx.exibirTableCustom(...args))),
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: "Exibe tabela com visualização avançada",
                    class: "d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white px-3 ms-2"
                  }, _hoisted_14))
                : _createCommentVNode("", true)
          ]),
          (_ctx.viewModel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectFiltro, (select, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createVNode(_component_SelectQueryBuilder, {
                            select: select,
                            model: _ctx.model,
                            showRemove: true,
                            onRemoverCampo: ($event: any) => (_ctx.removerCampo(index))
                          }, null, 8, ["select", "model", "onRemoverCampo"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("button", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.adicionarCampo())),
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: "Adicionar campo",
                              class: "d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white px-2 pb-2 pe-5"
                            }, _hoisted_27)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("button", {
                              id: "kt_drawer_selecao_campos_close",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmarCampo())),
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: "Aplicar seleção de campos",
                              class: "d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-success svg-icon-white px-2 pb-2 pe-5"
                            }, _hoisted_32)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "no-more-tables",
      class: _normalizeClass(["table-responsive", ['mh-' + _ctx.maxHeight]])
    }, [
      (!_ctx.showTableCustom)
        ? (_openBlock(), _createElementBlock("table", {
            key: 0,
            class: _normalizeClass([[_ctx.isloading && 'overlay overlay-block'], "table align-middle table-row-dashed fs-6 gs-7 dataTable no-footer table-hover border-bottom border-start border-end table-rounded"]),
            id: "kt_custom_table",
            role: "grid"
          }, [
            _createElementVNode("thead", _hoisted_33, [
              _createElementVNode("tr", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (cell.visible === undefined || cell.visible === true)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                          class: _normalizeClass([
                  cell.name && 'min-w-50px',
                  cell.sortable !== false && 'sorting',
                  _ctx.tableHeader.length - 1 === i && 'text-end min-w-150px',
                  _ctx.currentSort ===
                    `${
                      cell.sortingField ? cell.sortingField : cell.key
                    } desc` && 'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key} asc` &&
                    'sorting_asc',
                ]),
                          tabindex: "0",
                          rowspan: "1",
                          colspan: "1",
                          style: {"cursor":"pointer"}
                        }, [
                          (cell.type == 'checkbox')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input me-2",
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ischecked) = $event)),
                                  onChange: ($event: any) => (
                      _ctx.onCheckedRows(
                        $event.target.checked,
                        cell.sortingField ? cell.sortingField : ''
                      )
                    )
                                }, null, 40, _hoisted_37), [
                                  [_vModelCheckbox, _ctx.ischecked]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(cell.name), 1)
                        ], 10, _hoisted_35))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customTableHeader, (cell, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (cell.visible === undefined || cell.visible === true)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                          class: _normalizeClass([
                  cell.name && 'min-w-50px',
                  cell.sortable !== false && 'sorting',
                  _ctx.tableHeader.length - 1 === i && 'text-end min-w-150px',
                  _ctx.currentSort ===
                    `${
                      cell.sortingField ? cell.sortingField : cell.key
                    } desc` && 'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key} asc` &&
                    'sorting_asc',
                ]),
                          tabindex: "0",
                          rowspan: "1",
                          colspan: "1",
                          style: {"cursor":"pointer"}
                        }, [
                          (cell.type == 'checkbox')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input me-2",
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ischecked) = $event)),
                                  onChange: ($event: any) => (
                      _ctx.onCheckedRows(
                        $event.target.checked,
                        cell.sortingField ? cell.sortingField : ''
                      )
                    )
                                }, null, 40, _hoisted_40), [
                                  [_vModelCheckbox, _ctx.ischecked]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(cell.name), 1)
                        ], 10, _hoisted_38))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", _hoisted_41, [
              (_ctx.getItems.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: i,
                      class: _normalizeClass(['odd', _ctx.getCurrentRow === i ? 'bg-light-dark' : '']),
                      onClick: ($event: any) => (_ctx.selectCurrentRow(i))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                          (cell.visible === undefined || cell.visible === true)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                onDblclick: ($event: any) => (_ctx.onDoubleClick(item)),
                                class: _normalizeClass([_ctx.tableHeader.length - 1 === i && 'text-end']),
                                "data-title": cell.name
                              }, [
                                _renderSlot(_ctx.$slots, `cell-${cell.key}`, { row: item }, () => [
                                  _createTextVNode(_toDisplayString(item["prop"]), 1)
                                ])
                              ], 42, _hoisted_43))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customTableHeader, (header, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "w-auto",
                          key: index,
                          "data-title": header.name
                        }, [
                          (header.type === `datetime-utc`)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.utils.formatarDataHoraFusoHorario(item[header.key])), 1))
                            : (header.type === `datetime`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.utils.formatarDataHora(item[header.key])), 1))
                              : (header.type === `decimal`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.utils.formatarNumero(item[header.key])), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(item[header.key]), 1))
                        ], 8, _hoisted_44))
                      }), 128))
                    ], 10, _hoisted_42))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                    _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.emptyTableText), 1)
                  ]))
            ]),
            (_ctx.isloading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_54))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.showTableCustom)
        ? (_openBlock(), _createBlock(_component_KTDatatableFilter, {
            key: 1,
            data: _ctx.getItems,
            model: _ctx.model,
            isloading: _ctx.isloading,
            sortable: true,
            onSort: _ctx.sort,
            currentSort: _ctx.currentSort
          }, null, 8, ["data", "model", "isloading", "onSort", "currentSort"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            (_ctx.enableItemsPerPageDropdown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("select", {
                      name: "kt_customers_table_length",
                      class: "form-select form-select-sm form-select-solid",
                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rowsPage) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSizes, (pageSize) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: pageSize,
                          value: pageSize
                        }, _toDisplayString(pageSize), 9, _hoisted_58))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.rowsPage]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_el_pagination, {
              "current-page": _ctx.pagination.page,
              "onUpdate:current-page": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pagination.page) = $event)),
              onCurrentChange: _ctx.currentPageChange,
              "page-size": _ctx.pagination.rowsPerPage,
              layout: "prev, pager, next",
              total: _ctx.totalData,
              "hide-on-single-page": _ctx.hidePage,
              background: ""
            }, null, 8, ["current-page", "onCurrentChange", "page-size", "total", "hide-on-single-page"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}